import ViewConstructor from './../components/ViewConstructor';


class GalleryLogout extends ViewConstructor {
  componentDidEnter() {
    setTimeout(() => {
      $(`#${ this.state.generatedId } #logging-out-account`).trigger('click');  
    }, 50);
  }

  /**
  Renders a generic template. 
  */
  render() {
    return `
      <a href="${ this.state.baseUrl }" id="logging-out-account">logging out... click to redirect now</a>
    `;
  }
}

export default GalleryLogout;


// WEBPACK FOOTER //
// ./src/scripts/site/account-views/logout.js